import { useState, useEffect, useCallback } from "react";
import { getCampaigns, getCampaignDetail, getCampaignVouchers } from "../../api/campaign";

export function useCampaigns({ filter }) {
  const [campaigns, setCampaigns] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCampaigns = useCallback(async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getCampaigns(filter);
      setCampaigns(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchCampaigns(filter);
  }, [filter, fetchCampaigns]);

  return {
    campaigns,
    meta,
    loading,
    errorMsg,
    fetchCampaigns,
  };
}

export function useCampaignDetail({ campaign_id }) {
  const [campaign, setCampaign] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCampaignDetail = useCallback(async (id) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getCampaignDetail(id);
      setCampaign(data.data);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (campaign_id) {
      fetchCampaignDetail(campaign_id);
    }
  }, [campaign_id, fetchCampaignDetail]);

  return {
    campaign,
    loading,
    errorMsg,
    fetchCampaignDetail,
  };
}

export function useCampaignVouchers({ campaign_id, filter }) {
  const [vouchers, setVouchers] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchVouchers = useCallback(async (id, filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getCampaignVouchers(id, filter);
      setVouchers(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (campaign_id) {
      fetchVouchers(campaign_id, filter);
    }
  }, [campaign_id, filter, fetchVouchers]);

  return {
    vouchers,
    meta,
    loading,
    errorMsg,
    fetchVouchers,
  };
}
